module.exports = __webpack_public_path__ + "media/packs/common/assets/images/mimamori/mimamori_l-776830b3cfc111e4be67a837b2884d93.png";